import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LicensingAuthService } from '../services/licensing-auth.service';

/**
 * Route guard that ensures the user has an established DTIMS session.
 * If not authenticated, redirects the browser directly to the backend
 * login flow (skipping the empty `/login` pass-through component).
 *
 * Mirrors `apps/shell-app/src/guards/auth.guard.ts`.
 *
 * When the licensing app is hosted in the shell-app, `environment.okta` is
 * absent and this guard is not applied (see `getGuards()` in app.routes.ts).
 *
 * TODO(de-dup): Functionally identical to the shell-app guard apart from the
 * service type. Lift into `@deighton/shared-ui/auth` once both apps share a
 * common auth-service interface.
 */
export const authGuard: CanActivateFn = (): boolean => {
  const authService: LicensingAuthService = inject(LicensingAuthService);

  if (authService.isAuthenticated()) {
    return true;
  }

  authService.redirectToLogin();
  return false;
};
